import { render, staticRenderFns } from "./JobAttachmentsField.vue?vue&type=template&id=56a36c2f"
import script from "./JobAttachmentsField.vue?vue&type=script&lang=ts"
export * from "./JobAttachmentsField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports